import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/UserLogo.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-group-person",
    attrs: {
      "id": "entryPage"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "size": 1,
      "name": _vm.person.name,
      "url": _vm.person.avatar,
      "show-border": true,
      "border-width": 3,
      "border-color": "transparent"
    }
  })], 1)]), _c('div', {
    staticClass: "line"
  }), _c('group', [_c('group-title', {
    staticClass: "font-size-h4-large",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(i18n.tc("441"))]), _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("241")
    }
  }, [_c('div', {
    on: {
      "click": _vm.changeName
    }
  }, [_vm._v(_vm._s(_vm.person.name))]), _c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/czhanghao.png"
    }
  })])]), _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "title": i18n.tc("442")
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.person.phone))]), _c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/cshouji.png"
    }
  })])]), _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": _vm.person.is_admin !== 1,
      "title": i18n.tc("465")
    }
  }, [_c('div', {
    on: {
      "click": _vm.setManage
    }
  }, [_vm._v(_vm._s(_vm.person.is_admin === 1 ? i18n.tc("463") : i18n.tc("466")))]), _c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/role_manage.png"
    }
  })])]), _vm.person.is_admin !== 1 ? _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("467")
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.deletePerson.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/delete.png"
    }
  })])]) : _vm._e()], 1)], 1), _c('confirm', {
    ref: "confirm",
    attrs: {
      "show-input": "",
      "title": i18n.tc("468")
    },
    on: {
      "on-confirm": _vm.onConfirm
    },
    model: {
      value: _vm.showChangeName,
      callback: function ($$v) {
        _vm.showChangeName = $$v;
      },
      expression: "showChangeName"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };